export const dataHooks = {
    SUFFIX: 'list-item-section-suffix',
    TITLE: 'list-item-section-title',
};
export const TYPES = {
    WHITESPACE: 'whitespace',
    DIVIDER: 'divider',
    TITLE: 'title',
    SUBHEADER: 'subheader',
};
//# sourceMappingURL=ListItemSection.constants.js.map